/**
 * ROP Teams app — version constant.
 *
 * This MUST stay in lockstep with:
 *   - apps/ROP-teams/package.json  → "version"
 *   - apps/ROP-teams/appPackage/manifest.json → "version"
 *   - apps/ROP-teams/.env.example  → VITE_APP_VERSION
 *
 * Per global CLAUDE.md: every deploy bumps PATCH (fixes), MINOR (features),
 * MAJOR (breaking). Display visibly in UI (TopBar About popover + footer).
 */
export const APP_VERSION = '0.159.0';

/** Semantic marker — bumped independently of version for hotfix hardening. */
export const APP_BUILD_CHANNEL: 'dev' | 'uat' | 'prod' = 'dev';

/** Build timestamp, injected via VITE_BUILD_TIME or falls back to unknown. */
export const APP_BUILD_TIME: string =
  (import.meta.env.VITE_BUILD_TIME as string | undefined) ?? 'dev-build';

// Teams short name is "Retail"; matching here so the in-app topbar title
// tracks the Teams sidebar label. Full brand is "PCB Retail" (manifest
// name.full) - the logo component next to APP_NAME carries the PCB brand
// visually, so the text itself stays single-word clean.
export const APP_NAME = 'Retail';
export const APP_SUBTITLE = 'Phelps County Bank';
